(function (global) {
  var PREFIX = 'Sample ';
  var MAX = 5;

  function isSampleLine(item, sampleHandle) {
    if (!item) return false;
    if (sampleHandle && item.handle === sampleHandle) return true;
    if (item.handle === 'sample' || item.handle === 'flooring-sample') return true;
    if (item.product_type && String(item.product_type).toLowerCase() === 'sample') return true;
    return false;
  }

  function stylePropsFromLine(item) {
    var props = item.properties || {};
    var styles = [];
    Object.keys(props).forEach(function (key) {
      if (key.indexOf(PREFIX) === 0 && props[key]) styles.push(props[key]);
    });
    return styles;
  }

  function cartHasSampleForProduct(cart, parentHandle, sampleHandle) {
    if (!cart || !cart.items || !parentHandle) return false;
    return cart.items.some(function (item) {
      if (!isSampleLine(item, sampleHandle)) return false;
      var handles = (item.properties && item.properties._parent_handles) || '';
      return handles.split(',').filter(Boolean).indexOf(parentHandle) >= 0;
    });
  }

  function findSampleLine(cart, sampleHandle) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (isSampleLine(cart.items[i], sampleHandle)) return cart.items[i];
    }
    return null;
  }

  function buildMergedProperties(existingProps, label, parentHandle) {
    var props = Object.assign({}, existingProps || {});
    var styles = [];
    Object.keys(props).forEach(function (key) {
      if (key.indexOf(PREFIX) === 0 && props[key]) styles.push(props[key]);
    });
    if (styles.length >= MAX) throw new Error('max_samples');
    if (styles.indexOf(label) >= 0) throw new Error('duplicate');
    var handles = (props._parent_handles || '').split(',').filter(Boolean);
    if (parentHandle && handles.indexOf(parentHandle) >= 0) throw new Error('duplicate');
    var n = styles.length + 1;
    props[PREFIX + n] = label;
    if (parentHandle) handles.push(parentHandle);
    props._parent_handles = handles.join(',');
    return props;
  }

  function removeStyleFromLine(sampleLine, parentHandle, label) {
    var props = Object.assign({}, sampleLine.properties || {});
    var handles = (props._parent_handles || '').split(',').filter(Boolean);
    var idx = handles.indexOf(parentHandle);
    if (idx < 0) throw new Error('not_in_sample');
    handles.splice(idx, 1);
    var styles = stylePropsFromLine(sampleLine);
    var styleIdx = styles.indexOf(label);
    if (styleIdx >= 0) {
      var n = 1;
      var rebuilt = {};
      Object.keys(props).forEach(function (key) {
        if (key.indexOf(PREFIX) !== 0) rebuilt[key] = props[key];
      });
      styles.forEach(function (val, i) {
        if (i !== styleIdx && val) {
          rebuilt[PREFIX + n] = val;
          n += 1;
        }
      });
      props = rebuilt;
    }
    props._parent_handles = handles.join(',');
    if (!handles.length) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: sampleLine.key, quantity: 0 })
      });
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: sampleLine.key, quantity: 1, properties: props })
    });
  }

  function addStyleToCart(variantId, sampleHandle, label, parentHandle) {
    if (!variantId) {
      return Promise.reject(new Error('no_sample_product'));
    }
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (parentHandle && cartHasSampleForProduct(cart, parentHandle, sampleHandle)) {
          throw new Error('duplicate');
        }
        var sampleLine = findSampleLine(cart, sampleHandle);
        var merged;
        try {
          merged = sampleLine
            ? buildMergedProperties(sampleLine.properties, label, parentHandle)
            : buildMergedProperties({}, label, parentHandle);
        } catch (err) {
          throw err;
        }
        if (sampleLine) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: sampleLine.key, quantity: 1, properties: merged })
          }).then(function (r) {
            if (!r.ok) throw new Error('cart_error');
            return r.json();
          });
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: merged
          })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart_error');
          return r.json();
        });
      });
  }

  function formatLabel(productName, sku) {
    var name = (productName || '').trim();
    var id = (sku || '').trim();
    if (name && id) return name + ' (' + id + ')';
    return name || id;
  }

  global.BffSamplesCart = {
    PREFIX: PREFIX,
    MAX: MAX,
    isSampleLine: isSampleLine,
    stylePropsFromLine: stylePropsFromLine,
    cartHasSampleForProduct: cartHasSampleForProduct,
    findSampleLine: findSampleLine,
    buildMergedProperties: buildMergedProperties,
    removeStyleFromLine: removeStyleFromLine,
    addStyleToCart: addStyleToCart,
    formatLabel: formatLabel
  };
})(window);
